import React from 'react';
import Head from 'next/head'
import { get } from "lodash";
import { ContentfulApi } from "../../../api/ContentfulApi";
import TermsTemplate from "../../../components/Terms/TermsTemplate/TermsTemplate";
import { getServerSideLocaleData } from "../../../utils/server-side/getLocaleData";
import Breadcrumb from "../../../components/Breadcrumb";

const GoodNeighborPolicy = ({ terms, redirectUrl }) => {
    const showTerms = !!terms;
    return (
        <div>
            <Head>
                <title>Peerspace</title>
                <link rel="icon" href="https://assets.peerspace.com/peerspace_favicon-196x196.png?v=rb" />
            </Head>
            <div className="container pt-10">
                {showTerms &&
                    <div>
                        <Breadcrumb breadCrumbLinks={terms.breadCrumbLinks} redirectUrl={redirectUrl} />
                        <div className="row">
                            <div className="col-12">
                                <TermsTemplate {...terms} />
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export const getServerSideProps = async (context) => {
    const localeProps = await getServerSideLocaleData(context);
    const locale = get(localeProps ,'locale', 'en-US');
    const termsData = await ContentfulApi.getGoodNeighborPolicy(locale);
    return {
        props: {
            ...localeProps,
            redirectUrl: 'legal/terms/good-neighbor-policy',
            terms: termsData
        }
    }
}

export default GoodNeighborPolicy;
